
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Datakilde',
	'dataSourceId': 'Id',
	'dataSourceType': 'Type',
	'dataSourceName': 'Navn',
	'dataSourcePath': 'Sti',
	'showInfoForAll': 'Vis varighed for alle visualiseringer',
	'hideInfoForAll': 'Skjul varighed for alle visualiseringer',
	'showPerformanceDetails': 'Gentag alle widgetter for at inkludere performancedetaljer',
	'slotMappingField': 'Slot-mapninger',
	'slotDataMapping': 'Mapning',
	'slotID': 'Id',
	'slotCaption': 'Overskrift',
	'slotMandatory': 'Obligatorisk',
	'slotIsMandatory': 'Ja',
	'slotIsNotMandatory': 'Nej',
	'infoNotAvailable': 'Ikke tilgængelig',
	'performanceSection': 'Performance',
	'durationField': 'Varighed',
	'singleQueryTime': 'Serverforespørgsel (ms)',
	'multipleQueryTime': 'Serverforespørgsel %{name} (ms)',
	'liveWidgetTotalTime': 'Total (ms)',
	'renderTimeNotAvailable': 'Ikke tilgængelig',
	'renderInProgress': '(i gang)',
	'interactToTriggerQuery': 'Interaktion med widget for at udløse en forespørgsel',
	'fetchQuery': 'Hent forespørgsel',
	'showSQLMDX': 'Vis SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Oplysninger om forespørgsel',
	'queryInfoNotAvailable': 'Forespørgselsoplysninger er ikke tilgængelige',
	'query': 'Forespørgsel',
	'copy': 'Kopiér',
	'close': 'Luk'
});
